export const recoveryPrefix = 'bp-question-recovery:';
export const recoveryLifetime = 24 * 60 * 60 * 1000;
export function recoveryKey(user, question, type, tag) {
  return user?.id ? recoveryPrefix + JSON.stringify([user.id,user.tenantId ?? null,question?.id ?? null,question?.contentVersion ?? null,type ?? null,tag ?? null]) : null;
}
export function readRecovery(key, baseline, storage = sessionStorage, now = Date.now()) {
  if (!key) return null;
  const raw = storage.getItem(key);
  if (!raw) return null;
  try {
    const record = JSON.parse(raw);
    if (record.schema !== 1 || record.baseline !== baseline || !Number.isFinite(record.at) || now < record.at || now-record.at > recoveryLifetime || !record.value?.formData || typeof record.value.formData.text !== 'string' || (!Array.isArray(record.value.formData.options) || record.value.formData.options.some(option=>!option || typeof option.text!=='string' || typeof option.imageUrl!=='string' || typeof option.isCorrect!=='boolean'))) throw Error();
    return record;
  } catch { storage.removeItem(key); return null; }
}
export function writeRecovery(key, baseline, value, storage = sessionStorage, now = Date.now()) {
  if (!key) return;
  const raw = JSON.stringify({schema:1,baseline,at:now,value});
  if (raw.length > 1024 * 1024) throw Error('Draft too large');
  storage.setItem(key,raw);
}
export function clearQuestionRecovery(storage = sessionStorage) {
  for (let i=storage.length-1;i>=0;i--) { const key=storage.key(i);if(key?.startsWith(recoveryPrefix))storage.removeItem(key); }
}
